<template>
  <div class="rank-rule-item">
    <Row type="flex" class="rule-item-title" align="bottom">
      <Col :span="4" class="title-number">
        <div class="title-number__content">{{no}}</div>
        <div class="title-number__bottom"></div>
      </Col>
      <Col :span="20" class="title-content">{{title}}</Col>
    </Row>
    <div class="rule-item-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { Row, Col } from 'vant'
export default {
  name: 'RuleItem',
  components: { Row, Col },
  props: {
    no: {
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: ''
    }
  },
  created () {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang="less">
.rule-item{
  &-title{
    .title-number{
      position: relative;
      &__content{
        position: relative;
        font-weight: 800;
        font-size: 25px;
        color: #131a42;
        margin-left: 10px;
        z-index: 2;
      }
      &__bottom{
        position: absolute;
        z-index: 1;
        bottom: 0;
        left: 0;
        height: 13.5px;
        width: 34px;
        background-color: #afa2f9;
      }
    }
    .title-content{
      font-size: 18px;
      font-weight: bold;
      color: #131a42
    }
  }
  &-content{
    padding-top: 10px;
    font-size: 15px;
    color: #303967;
  }
}
</style>
